import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './theme.css';
import { AuthProvider } from './contexts/AuthContext';
import { LeadsProvider } from './contexts/LeadsContext';
import { installNumberStepping } from './lib/numberInput';

installNumberStepping();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <LeadsProvider>
        <App />
      </LeadsProvider>
    </AuthProvider>
  </React.StrictMode>,
);
